module.exports = __webpack_public_path__ + "static/media/publish-videos-images-tabletPro-es.2bfd4995.png";